@if(isOpenPopup){
<div class="fixed-center" class="{{localService.selectedLanguageCode}}">
    <ngb-toast [header]="localService.languageContent.billing.overwrite_discount" [autohide]="false"
        (hidden)="onAction(1)">
        <div class="banner">
            <div class="row">
                <div class="col-8">
                    <label style="font-size: large;">{{localService.languageContent.billing.amount}}</label>
                </div>
                <div class="col-4" style="text-align: right;">
                    <span class="en">{{(baseAmount ?? 0) | number: '1.2-2'}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <label class="radio-button">
                        <input type="radio" name="overwrite_price" [checked]="selectedRadioOption == 1"
                            (click)="onChecked(1)">
                        <span>&nbsp;{{localService.languageContent.billing.disc_percentage}}</span>
                    </label>
                </div>
                <div class="col-4" style="text-align: right;">
                    <input autocomplete="off" [id]="elementIds.btn_currentPrice" type="number" class="number"
                        [ngClass]="discountPercentage ? 'en' : ''" [(ngModel)]="discountPercentage"
                        (focus)="onAction(2)" (input)="onCalculate(true)"
                        placeholder="{{localService.languageContent.billing.price}}"
                        title="{{localService.languageContent.billing.price}}" />
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <label class="radio-button">
                        <input type="radio" name="overwrite_price" [checked]="selectedRadioOption == 2"
                            (click)="onChecked(2)">
                        <span>&nbsp;{{localService.languageContent.billing.discount_amount}}</span>
                    </label>
                </div>
                <div class="col-4" style="text-align: right;">
                    <input autocomplete="off" [id]="elementIds.btn_totalPrice" type="number" class="number"
                        [ngClass]="discountAmount ? 'en' : ''" [(ngModel)]="discountAmount" (focus)="onAction(3)"
                        (input)="onCalculate(false)" placeholder="{{localService.languageContent.billing.price}}"
                        title="{{localService.languageContent.billing.price}}" />
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <label style="font-size: large;">{{localService.languageContent.billing.after_discount}}</label>
                </div>
                <div class="col-4" style="text-align: right;">
                    <span class="en" style="font-weight: bold;">{{((baseAmount ?? 0) - (discountAmount ?? 0)) | number:
                        '1.2-2'}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="text-align: center;">
                    <button type="button" class="btn btn-primary" (click)="onAction(4)">
                        {{localService.languageContent.common.save}}
                    </button>
                </div>
            </div>
        </div>
    </ngb-toast>
</div>
}